import { isEmpty, isNotEmpty } from '../../helpers';
const INPUT_ACESSIBILITY_ERROR = '[TextArea - Accessibility Error] Se a prop "label" não for informada no TextArea é necessário informar o atributo "aria-label" para garantir melhor acessibilidade no formulário.';
const INPUT_LOADING_ACESSIBILITY_ERROR = '[TextArea - Accessibility Error] Quando o componente está com state="loading" a propriedade stateMessage é obrigatória.';
const INPUT_LABEL_WITHOUT_ID_ERROR = '[TextArea - Error] Para utilização da label com no componente é obrigatório a utilização de um id válido.';
export const runTextareaValidations = ({ 'aria-label': ariaLabel, id, label, state, stateMessage }) => {
    if (isEmpty(label) && isEmpty(ariaLabel))
        throw new Error(INPUT_ACESSIBILITY_ERROR);
    if (isNotEmpty(label) && isEmpty(id))
        throw new Error(INPUT_LABEL_WITHOUT_ID_ERROR);
    if (state === 'loading' && isEmpty(stateMessage))
        throw new Error(INPUT_LOADING_ACESSIBILITY_ERROR);
};
export const getQuantTyped = (value) => {
    return value ? value.toString().length : 0;
};
export const validation = (value) => {
    if (value) {
        if (Number.isInteger(value) && value >= 1) {
            return value;
        }
    }
    return undefined;
};
